import React from 'react';
import { Input } from '@tesla/informed-tds';
import { string } from 'prop-types';

const CityInput = ({ country, ...props }) => <Input {...props} />;

CityInput.propTypes = {
  country: string,
};

CityInput.defaultProps = {
  country: '',
};

export default CityInput;
